import React, { useRef } from 'react'
import { Form } from 'react-bootstrap'
import Select, { components } from 'react-select'
import { getIn, setIn } from 'formik'
import { DropdownIndicator, MultiValueContainer } from './FormSelectComponents'

const { Control, Group, Label } = Form

export default function FormSelect({
    field,
    form: {
        touched = {},
        errors = {},
        setFieldValue = () => { },
        setTouched = () => { },
    } = {},
    icon,
    options = [],
    groupProps = {},
    controlId,
    handleChange,
    isMulti = false,
    showSelectAll = false,
    isSearchable = false,
    disabled = false,
    hideSelectedOptions,
    ...props
}) {
    const showError = !!getIn(touched, field.name) && !!getIn(errors, field.name)
    const wrapperRef = useRef(null)
    // const showError = true;
    var timer = null

    const onChange = value => {
        setFieldValue(field.name, value)
        if (handleChange) {
           handleChange(value)
        }
    }

    const onFocus = () => {
        if (timer) {
            clearInterval(timer)
            timer = null
        }
        timer = setInterval(() => {
            if (!wrapperRef || !wrapperRef.current) {
                clearInterval(timer)
                return
            }
            let react_menu = wrapperRef.current.getElementsByClassName(
                'react-select__menu'
            )
            if (react_menu.length > 0) {
                wrapperRef.current.style.marginBottom =
                    react_menu[0].scrollHeight + 'px'
            } else {
                wrapperRef.current.removeAttribute('style')
            }
        }, 100)
    }

    const onBlur = () => {
        const _touched = setIn({ ...touched }, field.name, true)
        setTouched(_touched)
    }

    const onSelectAll = e => {
        e.preventDefault()
        e.stopPropagation()
        const newValue =
            !field.value || field.value.length < options.length ? [...options] : []
        setFieldValue(field.name, newValue)
    }

    const ValueContainer = isMulti
        ? MultiValueContainer
        : components.ValueContainer

    return (
        <Group controlId={controlId || field.name} ref={wrapperRef}>
            <Label className='form-label'>{props.label}</Label>
            <Select
                components={{ DropdownIndicator, ValueContainer }}
                className={`react-select-container ${showError ? 'is-invalid' : ''}`}
                classNamePrefix='react-select'
                hideSelectedOptions={
                    hideSelectedOptions !== undefined ? !!hideSelectedOptions : !isMulti
                }
                {...field}
                inputId={controlId || field.name}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange}
                options={options}
                isMulti={isMulti}
                onSelectAll={showSelectAll ? onSelectAll : null}
                isSearchable={isSearchable}
                selectedAll={
                    !!showSelectAll &&
                    !!isMulti &&
                    !!field.value &&
                    field.value.length === options.length
                }
                isDisabled={disabled}
            />
            {showError && (
                <Control.Feedback className='d-block' type='invalid'>
                    {getIn(errors, field.name)}
                </Control.Feedback>
            )}
        </Group>
    )
}
